// The canonical error envelope the API returns on a rejected login. Both
// platform auth handlers classify the failure on these fields.

/** Error-envelope fields `throwHttpError` attaches to the thrown `SdkError`. */
export interface LoginApiError {
  readonly code: string | null;
  readonly message: string | null;
}

/**
 * Read the API error code and the server's own message off a thrown error.
 *
 * `err.message` is a developer string — method, URL, request id, then the
 * server message — that call sites truncate before showing anything, so the
 * copy meant for the user has to come from the field rather than be parsed
 * back out of that string.
 */
export function readLoginApiError(err: unknown): LoginApiError {
  if (err === null || typeof err !== 'object') return { code: null, message: null };
  const envelope = err as { apiCode?: unknown; apiMessage?: unknown };
  return {
    code: typeof envelope.apiCode === 'string' ? envelope.apiCode : null,
    message: typeof envelope.apiMessage === 'string' ? envelope.apiMessage : null,
  };
}
